import { createFileRoute } from "@tanstack/react-router";
import { UserViewPage } from "@/pages/user-view/ui/user-view-page";

const UserViewRoute = () => {
  return <UserViewPage />;
};

export const Route = createFileRoute(
  "/_authed/$companySlug/_settings/settings/users/$userId/",
)({
  component: UserViewRoute,
});
